import { removeItemfromArray } from '../../../functions/lists'

const MultiselectCheckboxMovieExtension = ({field, form, ...props}) => {
    const { attrid, movieid, movieextension, value, cinemaid, attributes, disabled} = props

    if(!movieextension) {
        return ''
    }

    const movieExtensionPk = movieextension.pk
    const movieExtensionTechnologyAttributes = form.values.movieExtensionsItems[movieExtensionPk].technologyAttributes

    return (
        <label>
            <input
                {...props}
                {...field}
                type="checkbox"
                checked={value.movies.includes(movieid)}
                disabled={disabled}
                onChange={() => {
                    let removeAttribute = null
                    let extensionsArray = movieExtensionTechnologyAttributes ? movieExtensionTechnologyAttributes : []
                    const technicalAttribute = attributes[cinemaid].technical
                    
                    _.keys(technicalAttribute).map(attributeId => {
                        const attributeMovies = technicalAttribute[attributeId].movies

                        attributeMovies.map(attributeMovieId => {
                            if(attributeMovieId === movieid) {
                                if(!_.find(extensionsArray, extension => {
                                    return extension.id === attributeId
                                })) {
                                    extensionsArray.push({
                                        id: attributeId,
                                        name: technicalAttribute[attributeId].name
                                    })
                                }
                            }
                        })
                    })

                    if(value.movies.includes(movieid)) {
                        value.movies = removeItemfromArray(value.movies, movieid)
                        removeAttribute = true
                    } else {
                        value.movies.push(movieid)
                        removeAttribute = false
                    }

                    form.setFieldValue(field.name, value)

                    if(true === removeAttribute) {
                        const index = extensionsArray.findIndex(item => item.id === attrid)

                        if(-1 !== index) {
                            extensionsArray.splice(index, 1)

                            form.setFieldValue(`movieExtensionsItems.${movieExtensionPk}.technologyAttributes`, extensionsArray)
                        }
                    }

                    if(false === removeAttribute) {
                        extensionsArray.push({
                            id: attrid,
                            name: value.name
                        })

                        form.setFieldValue(`movieExtensionsItems.${movieExtensionPk}.technologyAttributes`, extensionsArray)
                    }

                    if(!_.contains(form.values.movieExtensionsEdited, movieExtensionPk)) {
                        form.values.movieExtensionsEdited.push(movieExtensionPk)
                    }
                }}
            />
            <span className="text-small-regular">{props.value.name}</span>
        </label>
    )
}

export default MultiselectCheckboxMovieExtension